import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IModule, IOnChangesObject, IScope} from "angular";
import {TransitionService} from "@uirouter/angularjs";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {AvtaleRessurs, Avtalestatus} from "felles/tjenester/ressurser/AvtaleRessurs";
import {Debugger} from "debug";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Transition} from "@uirouter/core/lib/transition/transition";

require('./avtale.scss');
const debug: Debugger = require('debug')('AvtaleKontroller');

export class AvtaleKontroller {

    static registrerKomponent(angular: IModule) {
        angular
            .component('waAvtale', {
                bindings: {avtaleId: '<', aktivArkfane:'<', visRedigerFaktureringsinformasjon: '<'},
                controller: AvtaleKontroller.forInjisering(),
                template: require('./avtale.html')
            });
    }

    static forInjisering = () => {
        return [
            regNavn.ng.$scope,
            regNavn.ng.ui.$transitions,
            AvtaleRessurs.regNavn,
            WebNavigasjon.regNavn,
            AvtaleKontroller
        ]
    };

    constructor(private $scope: IScope,
                private $transitions: TransitionService,
                private avtaleRes: AvtaleRessurs,
                private webNavigasjon: WebNavigasjon) {
    }

    avtaleId: string; //settes via bindings/$onChanges
    aktivArkfane:'grupper'|'brukere'|'aksepterteBetingelser'|'administrasjon' = 'grupper';//settes via bindings/lyttTilNavigasjon
    visRedigerFaktureringsinformasjon = false; //settes via bindings/$onChanges

    avtale: l.AvtaledetaljerModell;
    avtalestatus: Avtalestatus;

    visRedigerAvtale = false;

    private tilAvregistrering:Function[] = [];

    redigerAvtale() {
        this.visRedigerAvtale = true;
    }

    avtaleOppdatert(avtale: l.AvtaledetaljerModell, kontaktpersonEndret: boolean) {
        this.visRedigerAvtale = false;
        if (kontaktpersonEndret)
            this.webNavigasjon.gåTilAvtaler();
        else
            this.setAvtale(avtale);
    }

    avbrytRedigerAvtale() {
        this.visRedigerAvtale = false;
    }

    redigerFaktureringsinformasjon() {
        this.visRedigerFaktureringsinformasjon = true;
    }

    fakturainformasjonOppdatert(avtale: l.AvtaledetaljerModell) {
        this.setAvtale(avtale);
        this.visRedigerFaktureringsinformasjon = false;
    }

    avbrytRedigerFaktureringsinformasjon() {
        this.visRedigerFaktureringsinformasjon = false;
    }

    navigerTilGrupper() {
        this.webNavigasjon.gåTilAvtale(this.avtaleId);
    }

    navigerTilBrukere() {
        this.webNavigasjon.gåTilBrukereIAvtale(this.avtaleId);
    }

    navigerTilAksepterteBetingelser() {
        this.webNavigasjon.gåTilAksepterteBetingelser(this.avtaleId);
    }

    navigerTilAdministrasjon() {
        this.webNavigasjon.gåTilAvtaleAdministrasjon(this.avtaleId);
    }

    $onInit(): void {
        debug('$onInit', this.avtaleId, this.aktivArkfane);
        this.lyttTilNavigasjon();
    }

    $onChanges(endringer: IOnChangesObject): void {
        debug('$onChanges', endringer);
        dersomChangesInneholder(endringer, 'avtaleId', avtaleId => this.lastData(avtaleId));
        dersomChangesInneholder(endringer, 'visRedigerFaktureringsinformasjon', rediger => { if (rediger) this.redigerFaktureringsinformasjon() });
    }

    $onDestroy(): void {
        this.tilAvregistrering.forEach(avregistrering => avregistrering());
    }

    // private hjelpemetoder

    private lastData(avtaleId:string) {
        this.avtaleRes.hent(avtaleId).$promise
            .then(avtale => this.setAvtale(avtale));
    }

    private setAvtale(avtale: l.AvtaledetaljerModell) {
        this.avtale = avtale;
        this.avtalestatus = new Avtalestatus(this.avtale);
    }

    private lyttTilNavigasjon() {
        this.tilAvregistrering.push(this.$transitions.onSuccess({}, (trans: Transition) => {
            debug("$transitions.onSuccess", trans, trans.paramsChanged(), trans.params())
            this.aktivArkfane = trans.params().aktivArkfane;
            if (trans.params().redigerFaktureringsinformasjon == true)
                this.redigerFaktureringsinformasjon();
        }));
    }
}
